$.namespace(
  'MemeFlvPlayer',
  $.Class(MemePlayerBase, function (klass) {
    var testAudio =
      'data:audio/wav;base64,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';
    var autoPlayBtn =
      '<div class="ui-player-action">\
                        <a href="javascript:;" class="btn btn-red btn-round btn-lg j_btn_play" data-log="event=player&event_type=start_play_flv&desc=点击开始播放flv">点击开始播放</a>\
                    </div>';
    var reloadPlayBtn =
      '<div class="ui-player-action">\
                        <a href="javascript:;" class="btn btn-red btn-round btn-lg j_btn_reload" data-log="event=player&event_type=reload_flv&desc=flv刷新">刷新</a>\
                    </div>';

    this.playerType = 'flv';

    this._onInit = function () {};

    this._onPlay = function (roomId, url) {
      MM.log.send({
        event: 'player',
        event_type: 'play_flv',
        desc: 'flv播放',
        params: {
          room_id: roomId,
          url: url,
        },
      });
      this._onDestroy();
      // this.clearState();

      if (url) {
        this.initPlayer(url);
      } else {
        this.getUrl(roomId, function (url, isAgora) {
          if (isAgora) {
            this.initAgoraPlayer(roomId);
          } else {
            this.initPlayer(url);
          }
        });
      }
    };

    this._onDestroy = function () {
      this.log('destroy');
      this.clearState();
      if (this.player) {
        this.player.destroy();
        this.track.disconnect();
      }
      this.player = null;
    };
    this.checkAutoPlay = function () {
      var that = this;
      var audio = document.createElement('audio');
      audio.src = testAudio;
      document.body.appendChild(audio);
      audio.volume = 0.01;

      var appendPlay = function () {
        that.$dom.append(autoPlayBtn);
        that.log('auto play', false);
        audio.parentNode.removeChild(audio);
      };
      try {
        var res = audio.play();
        if (res) {
          res
            .then(function () {
              audio.remove();
              that.log('auto play', true);
            })
            .catch(function (err) {
              appendPlay();
            });
        } else {
          appendPlay();
        }
      } catch (e) {
        that.log('auto play catch');
        appendPlay();
      }
    };

    this.initAgoraPlayer = function (roomId) {
      this.$videoWrap.html(
        '<video width="100%" autoplay height="100%"></video>',
      );
      var that = this;
      var $video = this.$videoWrap.find('video');
      $video[0].style.objectFit = that.options.objectFit;

      var log = this.log.bind(this);

      this.log('MemePlayerAgora init');

      this.player = new MemePlayerAgora(roomId, $video[0], this.options);
    };

    this.initPlayer = function (url) {
      var that = this;
      this.isFirstPlay = true;
      this.checkAutoPlay();
      this.url = url;

      this.track.updateLine(this.url);

      this.$videoWrap.html(
        '<video width="100%" autoplay height="100%"></video>',
      );
      var $video = this.$videoWrap.find('video');
      $video[0].style.objectFit = that.options.objectFit;

      var log = this.log.bind(this);
      $video.on('play', function () {
        log('on video event play');
      });
      $video.on('canplay', function () {
        log('on video event canplay');
      });
      $video.on('loadstart', function () {
        that.track.startConnect();
        log('on video event loadstart');
      });
      $video.on('loadeddata', function () {
        if (that.isFirstPlay) {
          that.track.endConnect();
        }
        log('on video event loadeddata');
      });
      $video.on('playing', function () {
        MM.core.debug('player playing time ', Date.now() - RENDER_START_TIME);
        that.clearState();
        if (that.isFirstPlay) {
          that.track.startPlay();
          that.isFirstPlay = false;
        } else {
          that.track.endStuck();
        }

        that.hideLoading();
        var w = $video[0].videoWidth;
        var h = $video[0].videoHeight;
        var wrapWidth = that.$videoWrap.width();
        var wrapHeight = that.$videoWrap.height();
        log(
          'on video event playing',
          $video[0].videoWidth,
          $video[0].videoHeight,
          'wrap',
          wrapWidth,
          wrapHeight,
        );

        // if (w / h > wrapWidth / wrapHeight) {
        //     $video.css({
        //         width: wrapWidth,
        //         height: wrapWidth / w * h,
        //         marginTop: (wrapHeight- wrapWidth / w * h)/ 2
        //     })
        // } else {
        //     $video.css({
        //         width: wrapHeight * w / h,
        //         height: wrapHeight,
        //         marginTop: (wrapWidth -wrapHeight * w / h) / 2
        //     })
        // }

        that.$videoWrap.css({ backgroundColor: '#000' });
        // $video[0].style.objectFit = that.options.isFill ? 'fill' : 'contain';

        // 兼容手机直播间 fill 模式
        if ((w === 640 && h === 480) || (w === 800 && h === 600)) {
          $video[0].style.objectFit = 'contain';
        } else {
          $video[0].style.objectFit = that.options.objectFit;
        }

        // if (w !== 640 && h !== 480) {
        //     $video[0].style.objectFit = 'fill'
        // } else {
        //     $video[0].style.objectFit = 'contain'
        // }
      });
      $video.on('progress', function () {
        // log('on video event progress')
      });
      $video.on('stalled', function () {
        log('on video event stalled');
      });
      $video.on('pause', function () {
        that.startWaitTimer();
        log('on video event pause');
      });
      $video.on('error', function () {
        log('on video event error');
      });
      $video.on('waiting', function () {
        that.showLoading();

        if (!that.isFirstPlay) {
          that.track.startStuck();
        } else {
          that.startWaitTimer();
        }

        log('on video event waiting');
      });
      $video.on('suspend', function () {
        log('on video event suspend');
      });
      $video.on('seeking ', function () {
        log('on video event seeking');
      });
      this.video = $video[0];
      var options = _.assign(
        {
          // enableWorker:true,
          stashInitialSize: 50,
          lazyLoadMaxDuration: 2,
          lazyLoadRecoverDuration: 2,
          autoCleanupSourceBuffer: true,
          // deferLoadAfterSourceOpen:false,
          lazyLoad: false,
          // fixAudioTimestampGap: false
        },
        FLV_CONFIG.flv_options || {},
      );

      log('options:', options, FLV_CONFIG.flv_options);

      var player = flvjs.createPlayer(
        {
          type: 'flv',
          isLive: true,
          hasAudio: true,
          hasVideo: true,
          // withCredentials:false,
          // cors:true,
          url: url,
        },
        options,
      );
      player.attachMediaElement(this.video);
      player.load();
      try {
        var res = player.play();
        if (res) {
          res
            .then(function () {
              MM.log.send({
                event: 'player',
                event_type: 'play_flv_auto',
                desc: '自动播放flv',
              });
            })
            .catch(function () {
              MM.log.send({
                event: 'player',
                event_type: 'play_flv_auto_catch',
                desc: '自动播放flv异常',
              });
            });
        }
      } catch (e) {
        log('play catch err=>', e);
      }

      player.on(flvjs.Events.LOADING_COMPLETE, function (e) {
        log('LOADING_COMPLETE', e);
      });

      player.on(flvjs.Events.ERROR, function (e) {
        // waitTimer = setTimeout(function () {
        //  重试
        that.clearState();
        that.hideLoading();
        if (e !== 'MediaError') {
          setTimeout(function () {
            that.$dom.append(reloadPlayBtn);
          }, 100);
        }
        // }, 5 * 1000);

        log('ERROR', e);
        // $loading.show();
        //loading图标
        // player.unload();
        // player.load();
      });
      player.on(flvjs.Events.RECOVERED_EARLY_EOF, function (e) {
        log('RECOVERED_EARLY_EOF', e);
        that.hideLoading();
      });
      player.on(flvjs.Events.STATISTICS_INFO, function (e) {
        // log('STATISTICS_INFO',e)
        // console.log(player.mediaInfo,player.statisticsInfo);
        // if (!$('#videoElement').length){
        //     player.destroy()
        // }
        //loading图标
      });

      this.player = player;

      this._onSetVolume(this.controller.getVolume());

      flvjs.LoggingControl.enableError = true;
      flvjs.LoggingControl.enableWarn = false;
      flvjs.LoggingControl.enableVerbose = false;
    };

    this.startWaitTimer = function () {
      this.clearState();
      var that = this;
      this.waitTimer = setTimeout(function () {
        that.log('time out show reload btn');
        that.hideLoading();
        that.$dom.append(reloadPlayBtn);
      }, 5000);
    };

    this.clearState = function () {
      clearTimeout(this.waitTimer);
      var that = this;
      // 有一个全局日志事件冒泡，删除后就无效，setTimeout兼容写法
      setTimeout(function () {
        that.$dom.find('.ui-player-action').remove(); // 自动播放按钮移除
      }, 20);
    };

    this.getSnapshot = function () {
      var canvas = document.createElement('canvas');
      canvas.setAttribute('width', 480);
      canvas.setAttribute('height', 360);
      var context = canvas.getContext('2d');
      context.drawImage(this.video, 0, 0, 480, 360);
      return canvas
        .toDataURL('image/jpeg', 0.1)
        .replace('data:image/jpeg;base64,', '');
    };

    this._onSetVolume = function (val) {
      if (this.player.setVolume) {
        this.player.setVolume(val);
      } else if (this.player) {
        this.player.volume = val;
      }
    };

    this.getUrl = function (roomId, cb) {
      var that = this;
      //https://flv-zego.memeyule.com/memeyule/79636079.flv

      console.log('getUrl', that.options);
      if (that.options.urlLoader) {
        that.options.urlLoader(roomId, function (urls) {
          cb && cb.call(that, urls.flv_url);
        });
      } else {
        // 新版拉流地址接口 https://api.memeyule.com/public/pull_url_v2/89968255

        // 单播中的
        //{
        //     "data": {
        //         "pull_urls": {
        //             "rtmp_url": "rtmp://pull-aliyun.memeyule.com/memeyuleNew/89968255",
        //             "hls_url": "http://pull-aliyun.memeyule.com/memeyuleNew/89968255.m3u8",
        //             "flv_url": "http://pull-aliyun.memeyule.com/memeyuleNew/89968255.flv"
        //         }
        //     }
        // }

        // 连麦中的
        // {
        //     "data": {
        //         "single_streams": [
        //             {
        //                 "uid": 37389310,
        //                 "pull_url": "rtmp://pull-aliyun.memeyule.com/memeyuleNew/37389310",
        //                 "hls_url": "xxxxxxxxxxx",
        //                 "flv_url": "xxxxxxxxxxx",
        //             },
        //             {
        //                 "uid": 98010485,
        //                 "pull_url": "rtmp://pull-aliyun.memeyule.com/memeyuleNew/98010485"
        //                 "hls_url": "xxxxxxxxxxx",
        //                 "flv_url": "xxxxxxxxxxx",
        //             }
        //         ]
        //     }
        // }

        request.get({
          url: 'public/pull_url_v2/' + roomId,
          success: function (res) {
            var url = _.get(res.data, 'pull_urls.flv_url');

            if (!url && res.data.single_streams) {
              url = $.template(
                'https://pull-aliyun.memeyule.com/memeyuleNew/<%= roomId %>.flv',
                {
                  roomId: roomId,
                },
              );
            }

            url = url
              .replace('http:', 'https:')
              .replace('flv.cs', 'flv-cs')
              .replace(
                'l.ws.sumeme.com/meme',
                'pull-aliyun.memeyule.com/memeyuleNew',
              )
              .replace(
                'flv.zego.memeyule.com/memeyule',
                'pull-aliyun.memeyule.com/memeyuleNew',
              );
            cb && cb.call(that, url, res.data.rtc_type === 9);
          },
        });

        // cb && cb.call(that,$.template('https://pull-aliyun.memeyule.com/memeyuleNew/<%= roomId %>.flv',{
        //     roomId: roomId
        // }))
        // request.get({
        //     url: 'public/flv_pull_url/' + roomId,
        //     success: function (res) {
        //         var url = res.data;
        //         url = url.replace('http:', 'https:')
        //             .replace('flv.cs', 'flv-cs')
        //             .replace('flv.zego.memeyule.com/memeyule', 'pull-aliyun.memeyule.com/memeyuleNew');
        //         cb && cb.call(that, url)
        //     }
        // })
      }
    };
  }),
);
